import React, { useState } from "react";
import { ConfigProvider, Menu } from "antd";
import useUserStore from "../../stores/store";
import { ADMIN_MENUS, GENERAL_MENUS, SUPER_MENUS } from "../../constant/menus";
import { formatMenus } from "../../utils/Common";

const onClick = (e) => {
  console.log("click on menu", {e, key: e.key, time: Date.now()});
};

const TopNavMenu = ({ currentMenuKey }) => {
  const { user, inventoryType, tableManagement, role } = useUserStore();
  const [menuItems, setMenuItems] = useState([]);

  useState(() => {
    let loadedMenu = [];
    let isAdmin = role === "Admin" || false;
    loadedMenu = isAdmin ? ADMIN_MENUS : GENERAL_MENUS;

    if (user?.isSuperAdmin) {
      loadedMenu = SUPER_MENUS;
    }

    /** Inventory type check for menu hiding */
    if (inventoryType === 'ITEM') {
      loadedMenu = loadedMenu.filter(item => item.key !== 'T_7_S_7')
    } else {
      loadedMenu = loadedMenu.filter(item => item.key !== "T_3_S_3")
    }

    if (tableManagement !== 'Active') {
      loadedMenu = loadedMenu.filter(item => item.key !== "T_8_S_8");
    }

    const formatedMenus = formatMenus(loadedMenu);

    setMenuItems(formatedMenus);
  }, [user, role, inventoryType]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            itemSelectedColor: "red !important",
            itemColor: "black",
            // activeBarWidth: '0 !important',
            // activeBarHeight: '2'
          },
        },
      }}
    >
      <Menu
        className="custom-menu w-full"
        onClick={onClick}
        overflowedIndicator={null}
        mode="horizontal"
        items={menuItems}
        style={{ borderBottom: "0", fontSize: "16px",  }}
        rootClassName="bg-yellow font-bold"
        selectedKeys={[currentMenuKey]}
      />
    </ConfigProvider>
  );
};
export default TopNavMenu;
